import { Grid, Paper } from "@mui/material"
import { Title } from "components/Common/Title"
import { DeviceEventList } from "components/Device/DeviceEventList"
import { useAppDispatch, useAppSelector } from "hooks"
import { useEffect } from "react"
import { useParams } from "react-router-dom"
import deviceService from "services/deviceService"
import organizationService from "services/organizationService"
import { setCurrentDevice, setDevicesEvents } from "slices/deviceSlice"
import { setCurrentOrganization } from "slices/organizationSlice"

export function Device() {
  const { id, deviceId } = useParams()
  const dispatch = useAppDispatch()

  const currentDevice = useAppSelector((state) => state.device.currentDevice)
  const currentOrganization = useAppSelector((state) => state.organization.currentOrganization)

  useEffect(() => {
    if (currentOrganization === undefined && id) {
      organizationService
        .getOrganization(id)
        .then((organization) => {
          dispatch(setCurrentOrganization(organization))
        })
        .catch((err) => {
          console.log(err)
        })
    }

    if (deviceId && (currentDevice === undefined || currentDevice.id !== deviceId)) {
      deviceService
        .getDevice(deviceId)
        .then((device) => {
          dispatch(setCurrentDevice(device))

          deviceService
            .getDeviceEvents(device.id)
            .then((events) => {
              dispatch(setDevicesEvents(events))
            })
            .catch((err) => {
              console.log(err)
            })
        })
        .catch((err) => {
          console.log(err)
        })
    }
  }, [currentDevice, currentOrganization, deviceId, dispatch, id])

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Paper sx={{ p: 2, display: "flex", flexDirection: "column" }}>
          <Grid container paddingBottom={2}>
            <Grid item xs>
              <Title>DEVICE EVENTS</Title>
            </Grid>
            <Grid item></Grid>
          </Grid>
          <DeviceEventList />
        </Paper>
      </Grid>
    </Grid>
  )
}
